// extracted by mini-css-extract-plugin
module.exports = {"paperContainer":"BillerStatus_paperContainer__3cg7B","title":"BillerStatus_title__2ewZM","mainContainer":"BillerStatus_mainContainer__1T0zb"};